export default "__VITE_ASSET__C6i8xjaj__"